// extracted by mini-css-extract-plugin
module.exports = {"desktopModalPaper":"FeatureOnboarding_desktopModalPaper__L2Zo6","modalFooter":"FeatureOnboarding_modalFooter__3iqfT","modalPaper":"FeatureOnboarding_modalPaper__1uXT1"};